import SvgIcon from "@mui/material/SvgIcon";

interface CloseDrawerIconProps {
  children?: React.ReactNode;
  fontSize?: number | string;
  color?: string;
}

/**
 * Hides the sidebar.
 *
 * The same panel as OpenDrawerIcon, with the rail filled to show the sidebar
 * is currently open - so the pair reads as one control in two states rather
 * than two unrelated glyphs.
 */
const CloseDrawerIcon: React.FC<CloseDrawerIconProps> = (props) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        fontSize: props.fontSize ?? "inherit !important",
        color: props.color,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.7,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    >
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      <path d="M9.5 4v16" />
      <path
        d="M5.5 5.6h3.9v12.8H5.5a1.6 1.6 0 0 1-1.6-1.6V7.2a1.6 1.6 0 0 1 1.6-1.6Z"
        fill="currentColor"
        stroke="none"
        opacity="0.22"
      />
    </SvgIcon>
  );
};

export default CloseDrawerIcon;
